module.exports = __webpack_public_path__ + "img/jiuzhou-passenger.b1485328.png";